import React, { useState } from "react";
import { AppBar, Toolbar, IconButton, InputBase, Menu, MenuItem, Fab, Link } from "@material-ui/core";
import {
	Menu as MenuIcon,
	MailOutline as MailIcon,
	NotificationsNone as NotificationsIcon,
	Person as AccountIcon,
	Search as SearchIcon,
	Send as SendIcon,
	ArrowBack as ArrowBackIcon,
} from "@material-ui/icons";
import classNames from "classnames";
import Cookies from "universal-cookie";

// styles
import useStyles from "./styles";

// components
import { Badge, Typography, Button } from "../Wrappers/Wrappers";
import Notification from "../Notification/Notification";
import UserAvatar from "../UserAvatar/UserAvatar";

// context
import { useLayoutState, useLayoutDispatch, toggleSidebar } from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";
import Constants from "../../utils/consts";

const messages = [
	{
		id: 0,
		variant: "warning",
		name: "Jane Hew",
		message: "Hey! How is it going?",
		time: "9:32",
	},
	{
		id: 1,
		variant: "success",
		name: "Lloyd Brown",
		message: "Check out my new Dashboard",
		time: "9:18",
	},
	{
		id: 2,
		variant: "primary",
		name: "Mark Winstein",
		message: "I want rearrange the appointment",
		time: "9:15",
	},
	{
		id: 3,
		variant: "secondary",
		name: "Liana Dutti",
		message: "Good news from sale department",
		time: "9:09",
	},
];

const notifications = [
	{ id: 0, color: "warning", message: "Check out this awesome ticket" },
	{
		id: 1,
		color: "success",
		type: "info",
		message: "What is the best way to get ...",
	},
	{
		id: 2,
		color: "secondary",
		type: "notification",
		message: "This is just a simple notification",
	},
	{
		id: 3,
		color: "primary",
		type: "e-commerce",
		message: "12 new orders has arrived today",
	},
];

export default function Header(props) {
	var classes = useStyles();

	const cookies = new Cookies();
	var username = cookies.get("username", { path: "/" });

	// global
	var layoutState = useLayoutState();
	var layoutDispatch = useLayoutDispatch();
	var userDispatch = useUserDispatch();

	// local
	var [mailMenu, setMailMenu] = useState(null);
	var [isMailsUnread, setIsMailsUnread] = useState(true);
	var [notificationsMenu, setNotificationsMenu] = useState(null);
	var [isNotificationsUnread, setIsNotificationsUnread] = useState(true);
	var [profileMenu, setProfileMenu] = useState(null);
	var [isSearchOpen, setSearchOpen] = useState(false);
	var [search, setSearch] = useState("");

	var currentEventName = cookies.get("currentEventName", { path: "/" });

	return (
		<AppBar position="fixed" className={classes.appBar}>
			<Toolbar className={classes.toolbar}>
				<IconButton
					color="inherit"
					onClick={() => toggleSidebar(layoutDispatch)}
					className={classNames(classes.headerMenuButton, classes.headerMenuButtonCollapse)}
				>
					{layoutState.isSidebarOpened ? (
						<ArrowBackIcon
							classes={{
								root: classNames(classes.headerIcon, classes.headerIconCollapse),
							}}
						/>
					) : (
						<MenuIcon
							classes={{
								root: classNames(classes.headerIcon, classes.headerIconCollapse),
							}}
						/>
					)}
				</IconButton>
				<Typography variant="h6" weight="medium" className={classes.logotype}>
					Accademia Nazionale del Cinema
				</Typography>
				<Typography variant="h6" weight="medium" className={classes.logotype} style={{ marginLeft: "20px" }}>
					{Constants.apisFolder.indexOf("test") != -1 ? "TEST" : "LIVE"}
				</Typography>
				<div className={classes.grow} />
				<div
					className={classNames(classes.search, {
						[classes.searchFocused]: isSearchOpen,
					})}
				>
					<div
						className={classNames(classes.searchIcon, {
							[classes.searchIconOpened]: isSearchOpen,
						})}
						style={{ zIndex: 1000 }}
						onClick={() => {
							setSearchOpen(!isSearchOpen);
							setSearch("");
							props.onSearch("");
							if (isSearchOpen && window.location.href.includes("search")) window.history.go(-1);
						}}
					>
						<SearchIcon classes={{ root: classes.headerIcon }} />
					</div>
					<InputBase
						placeholder="Cerca…"
						style={{ color: "white" }}
						value={search}
						onFocus={() => (window.location.href = "/#/billing/search")}
						onChange={t => {
							setSearch(t.target.value);
							props.onSearch(t.target.value);
						}}
						classes={{
							root: classes.inputRoot,
							input: classes.inputInput,
						}}
					/>
				</div>
				<IconButton
					aria-haspopup="true"
					color="inherit"
					className={classes.headerMenuButton}
					aria-controls="profile-menu"
					onClick={e => setProfileMenu(e.currentTarget)}
				>
					<AccountIcon classes={{ root: classes.headerIcon }} />
				</IconButton>
				<Menu
					id="mail-menu"
					open={Boolean(mailMenu)}
					anchorEl={mailMenu}
					onClose={() => setMailMenu(null)}
					MenuListProps={{ className: classes.headerMenuList }}
					className={classes.headerMenu}
					classes={{ paper: classes.profileMenu }}
					disableAutoFocusItem
				>
					<div className={classes.profileMenuUser}>
						<Typography variant="h4" weight="medium">
							New Messages
						</Typography>
						<Typography className={classes.profileMenuLink} component="a" color="secondary">
							{messages.length} New Messages
						</Typography>
					</div>
					{messages.map(message => (
						<MenuItem key={message.id} className={classes.messageNotification}>
							<div className={classes.messageNotificationSide}>
								<UserAvatar color={message.variant} name={message.name} />
								<Typography size="sm" color="text" colorBrightness="secondary">
									{message.time}
								</Typography>
							</div>
							<div
								className={classNames(
									classes.messageNotificationSide,
									classes.messageNotificationBodySide
								)}
							>
								<Typography weight="medium" gutterBottom>
									{message.name}
								</Typography>
								<Typography color="text" colorBrightness="secondary">
									{message.message}
								</Typography>
							</div>
						</MenuItem>
					))}
					<Fab variant="extended" color="primary" aria-label="Add" className={classes.sendMessageButton}>
						Send New Message
						<SendIcon className={classes.sendButtonIcon} />
					</Fab>
				</Menu>
				<Menu
					id="notifications-menu"
					open={Boolean(notificationsMenu)}
					anchorEl={notificationsMenu}
					onClose={() => setNotificationsMenu(null)}
					className={classes.headerMenu}
					disableAutoFocusItem
				>
					{notifications.map(notification => (
						<MenuItem
							key={notification.id}
							onClick={() => setNotificationsMenu(null)}
							className={classes.headerMenuItem}
						>
							<Notification {...notification} typographyVariant="inherit" />
						</MenuItem>
					))}
				</Menu>
				<Menu
					id="profile-menu"
					open={Boolean(profileMenu)}
					anchorEl={profileMenu}
					onClose={() => setProfileMenu(null)}
					className={classes.headerMenu}
					classes={{ paper: classes.profileMenu }}
					disableAutoFocusItem
				>
					<div className={classes.profileMenuUser}>
						<Typography variant="h4" weight="medium">
							{username}
						</Typography>
						<Typography className={classes.profileMenuLink} component="a"></Typography>
					</div>

					<MenuItem
						className={classNames(classes.headerMenuItem)}
						onClick={() => {
							setProfileMenu(null);
							window.location.href = "#/billing/usersettings";
						}}
					>
						<AccountIcon className={classes.profileMenuIcon} /> Profile
					</MenuItem>
					{false && (
						<MenuItem className={classNames(classes.profileMenuItem, classes.headerMenuItem)}>
							<AccountIcon className={classes.profileMenuIcon} /> Tasks
						</MenuItem>
					)}
					{false && (
						<MenuItem className={classNames(classes.profileMenuItem, classes.headerMenuItem)}>
							<AccountIcon className={classes.profileMenuIcon} /> Messages
						</MenuItem>
					)}
					<div className={classes.profileMenuUser}>
						<Typography
							className={classes.profileMenuLink}
							color="primary"
							onClick={() => signOut(userDispatch, props.history)}
						>
							Esci
						</Typography>
					</div>
				</Menu>
			</Toolbar>
		</AppBar>
	);
}
